import Alpine from "alpinejs";
import { userPreferences } from "./userPreferences";
import { uiTheme } from "./ui/theme";
import { uiFontSize } from "./ui/fontSize";
import { webShare } from "./webShare";
import { panchangam } from "./panchangam";
import { i18n } from "./i18n";
import { panelStates } from "./panelStates";
import { pwa } from "./pwa";
import { appUpdater } from "./appUpdater";
import { visheshaDates } from "./visheshaDates";
import { notification } from "./notification";
import onboarding from "./onboarding";

export const initAlpineStores = function () {
  const alpineStores = {
    userPreferences,
    pwa,
    i18n,
    notification,
    uiTheme,
    uiFontSize,
    webShare,
    panelStates,
    panchangam,
    
    appUpdater,
    visheshaDates,
    onboarding
  };

  for (const [storeName, storeObject] of Object.entries(alpineStores)) {
    console.log(storeName, storeObject);

    Alpine.store(storeName, storeObject);
  }

  // Run initial setup BEFORE revealing UI
  // uiFontSize._setBaseFontSize();
  // panelStates._loadState();
  // uiTheme._applyTheme();

  // reveal
  requestAnimationFrame(() => {
    document.documentElement.removeAttribute("x-cloak");
  });
};
